module.exports = __webpack_public_path__ + "static/media/dishes.b8546a22.svg";